import type { SearchSortOrder, default as SearchTableQuery, } from "../store/schema/SearchTableQuery";

/**
 * The sort order the user sees for a search table. This can differ from the requested
 * `searchSortOrder`, which must stay unchanged so paging requests match the first page.
 */
export default function getDisplayedSearchSortOrder(searchTableQuery: SearchTableQuery | undefined): SearchSortOrder | undefined {
    const searchSortOrder = searchTableQuery?.searchSortOrder;
    return searchSortOrder === "Hybrid"
        ? (searchTableQuery?.displaySearchSortOrder ?? searchSortOrder)
        : searchSortOrder;
}
